module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_case_02-23123f1f4a23f836cafca08ed419ad59.png";